export default function resolvePassThrough(passThrough, ruleProps) {
  if (typeof passThrough === 'function') {
    return passThrough(ruleProps);
  }

  return passThrough;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/es/resolvePassThrough.js
// module id = 849
// module chunks = 1